function compute(money) {    //上海市仲裁委
    // money = $("#money").val();
    // $sea_money = $("#sea_money").val();
    // $sea_money_change = $("#sea_money_change").val();
    // money = Number(money) + Number($sea_money) * Number($sea_money_change);
    var total_money_1,total_money_2,sum
    if (0 < money && money <= 1000) {
        total_money_1 = 100;
    }
    else if (money > 1000 && money <= 50000) {
        total_money_1 = 100 + (money - 1000) * 0.05;
    }
    else if (money > 50000 && money <= 100000) {
        total_money_1 = 2550 + (money - 50000) * 0.04;
    }
    else if (money > 100000 && money <= 200000) {
        total_money_1 = 4550 + (money - 100000) * 0.03;
    }
    else if (money > 200000 && money <= 500000) {
        total_money_1 = 7550 + (money - 200000) * 0.02;
    }
    else if (money > 500000 && money <= 1000000) {
        total_money_1 = 13550 + (money - 500000) * 0.01;
    }
    else if (money > 1000000) {
        total_money_1 = 18550 + (money - 1000000) * 0.005;
    } else {
        total_money_1 = 0;
    }

    if (0 < money && money <= 200000) {
        total_money_2 = 3000;
    }
    else if (money > 200000 && money <= 500000) {
        total_money_2 = 3000 + (money - 200000) * 0.012;
    }
    else if (money > 500000 && money <= 1000000) {
        total_money_2 = 6600 + (money - 500000) * 0.01;
    }
    else if (money > 1000000 && money <= 5000000) {
        total_money_2 = 11600 + (money - 1000000) * 0.004;
    }
    else if (money > 5000000 && money <= 10000000) {
        total_money_2 = 27600 + (money - 5000000) * 0.003;
    }
    else if (money > 10000000 && money <= 20000000) {
        total_money_2 = 42600 + (money - 10000000) * 0.002;
    }
    else if (money > 20000000 && money <= 40000000) {
        total_money_2 = 62600 + (money - 20000000) * 0.001;
    }
    else if (money > 40000000) {
        total_money_2 = 82600 + (money - 40000000) * 0.0005;
    }
    else {
        total_money_2 = 0;
    }

    total_money_1 = parseInt(total_money_1);  //案件受理费
    total_money_2 = parseInt(total_money_2);   //案件处理费
    sum=total_money_1+total_money_2
    return {"total_money_1":total_money_1,"total_money_2":total_money_2,"sum":sum}  //总计


}


function Calculate(amount) {  //潍坊仲裁委员会
    var acceptfee
    if (amount <= 0 ) {
            alert ("请输入正确的数值！");
            return;
        }
    if (amount <= 1000) {
        acceptfee = 50;
        }
    else if (amount <= 50000) {
        acceptfee = 50 + (amount - 1000) * .04;
        }
    else if (amount <= 100000) {
        acceptfee = 2010 + (amount - 50000) * .035;
        }
    else if (amount <= 200000) {
        acceptfee = 3760 + (amount - 100000) * .025;
        }
    else if (amount <= 500000) {
        acceptfee = 6260 + (amount - 200000) * .015;
        }
    else if (amount <= 1000000) {
        acceptfee = 10760 + (amount - 500000) * .008;
        }
    else {
        acceptfee = 14760 + (amount - 1000000) * .004;
        }
    
    return acceptfee
}


function IncUseNumber(field){
 
    let oftenuse=localStorage.getItem('oftenuse')   ; 
    oftenuse=JSON.parse(oftenuse) || {};
    // let oftenuse=wx.getStorageSync('oftenuse') || {}
    let num=oftenuse[field] || 0
    num=num+1
    oftenuse[field]=num

    localStorage.setItem('oftenuse', JSON.stringify(oftenuse))

    // wx.setStorage({
    //   data: oftenuse,
    //   key: 'oftenuse',
    // })
  
  
}

function SetMinHeight(){
    document.getElementById("calbox").style.minHeight = (window.innerHeight-80)+'px;';
    // console.log('SetMinHeight window.innerHeight:',window.innerHeight)

    // var a = document.getElementsByClassName("el-date-editor--date")//通过class属性来获取所有满足的元素，返回的是一个类数组，没有返回一个空数组
    // console.log(a)
    // for(let p of a){
    //     p.style.width=''
    //     p.style.maxWidth=''

    //     for(let d of p.children){
    //         if(d.localName=='input'){
    //             d.style.width=''
    //             d.style.maxWidth=''
    //             console.log('1111111')
    //         }
    //     }
  
    // }

}






module.exports = {
    IncUseNumber: IncUseNumber,
    SetMinHeight:SetMinHeight,
   
}